import React from 'react';
import { CustomSwitch } from '../../../svg/UtilsIcons';

const WebDashboardEditToggles = ({
  mode,
  t,
  isFixedWidthMode,
  multiSelectEnabled,
  externalFixedWidthControl,
  externalMultiSelectControl,
  handleFixedWidthToggle,
  handleMultiSelectToggle,
}) => {
  if (mode !== 'edit' || (externalFixedWidthControl && externalMultiSelectControl)) {
    return null;
  }

  return (
    <div className="web-dashboard-edit-toggles">
      {!externalFixedWidthControl ? (
        <div className="web-dashboard-edit-toggle">
          <label className="form-lbl" style={{ color: 'var(--header-color)', padding: '4px 0px' }}>
            {t.fixedWidthDashboard}
          </label>

          <CustomSwitch
            checked={isFixedWidthMode}
            onChange={handleFixedWidthToggle}
          />
        </div>
      ) : null}

      {!externalMultiSelectControl ? (
        <div className="web-dashboard-edit-toggle">
          <label className="form-lbl" style={{ color: 'var(--header-color)', padding: '4px 0px' }}>
            {t.multiSelectWidgets || 'Multi Select'}
          </label>

          <CustomSwitch
            checked={multiSelectEnabled}
            onChange={handleMultiSelectToggle}
          />
        </div>
      ) : null}
    </div>
  );
};

export default WebDashboardEditToggles;
